import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'

import Loader from 'src/components/Loader/Loader'
import { Layout, Container, PageTitle, Content } from 'src/components/Layout'
import HtmlMarkdown from 'src/components/Render/HtmlMarkdown'
import { isEmpty, getRouterLocationState } from 'src/utils/helpers'
import intlMessagesApp from 'src/modules/App/translations'
import styles from './CustomPage.module.less'
import withToast from 'src/components/Toast'
class CustomPage extends Component {
  componentDidMount() {
    const { location, getCustomContent } = this.props

    // Get details of main menu item
    const locationState = getRouterLocationState(location, 'listItem')

    // Load content from page clicked in main menu item
    if (
      locationState &&
      locationState.hasOwnProperty('requestPath') &&
      !isEmpty(locationState.requestPath)
    ) {
      getCustomContent(locationState.requestPath)
    }
  }

  componentDidUpdate(prevProps) {
    const { intl, getCustomContentResponse, toast } = this.props

    // If there is a response and it changed (it's empty object while submitting)
    if (
      !isEmpty(getCustomContentResponse) &&
      getCustomContentResponse !== prevProps.getCustomContentResponse
    ) {
      // If there was error getting record
      if (getCustomContentResponse.success !== true) {
        toast({
          title: intl.formatMessage(intlMessagesApp.appErrorTitle),
          description:
            getCustomContentResponse.message ||
            intl.formatMessage(intlMessagesApp.appErrorDescription),
          status: 'error',
        })
      }
    }
  }

  render() {
    const { location, isGetCustomContentInProgress, getCustomContentResponse } = this.props

    // Get details of main menu item
    const locationState = getRouterLocationState(location, 'listItem')

    const title =
      locationState && locationState.hasOwnProperty('name') && !isEmpty(locationState.name)
        ? locationState.name
        : this.props.customPageTitle

    // Take response data for this custom page
    const payload =
      !isEmpty(getCustomContentResponse) &&
      getCustomContentResponse.hasOwnProperty('payload') &&
      !isEmpty(getCustomContentResponse.payload)
        ? getCustomContentResponse.payload
        : null

    // Get custom content (HTML) from the response of this custom page
    const content =
      payload && payload.hasOwnProperty('customContent') && !isEmpty(payload.customContent)
        ? payload.customContent
        : ''

    return (
      <Layout>
        <Content>
          <PageTitle showBackMobile={true} title={title} />
          <Container padder className={styles.container}>
            {isGetCustomContentInProgress ? (
              <Loader styleVariation='staticWithHeight' />
            ) : (
              <div className={styles.customContentHolder}>
                <HtmlMarkdown>{content}</HtmlMarkdown>
              </div>
            )}
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default withRouter(injectIntl(withToast(CustomPage)))
